import React from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { viewPDF } from '../services';
import language from '../../../assets/languages/language';

function PrintButton({ mockListLength, item, index, dropdownOpen, dropdownOpenIndex, toggle }) {
  return (
    <span className='privetinfo-dropdown'>
      <ButtonDropdown
        className={index + 1 === mockListLength ? 'dropup' : ''}
        isOpen={dropdownOpenIndex === index ? dropdownOpen : false}
        toggle={() => toggle(index)}
      >
        <DropdownToggle
          className='btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20'
          caret
        >
          {language.LC().PRINT}
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem
            value='public'
            onClick={() => {
              viewPDF({ mock_id: item.id, type: 'question' }).then(resp => {
                const myWindow = window.open(resp.pdf);
                myWindow.focus();
              });
            }}
          >
            <i className='fa fa-print color-black' aria-hidden='true' />
            {language.LC().PRINT_Q_MOCK}
          </DropdownItem>
          <DropdownItem
            value='private'
            onClick={() => {
              viewPDF({ mock_id: item.id, type: 'questionAnswer' }).then(resp => {
                const myWindow = window.open(resp.pdf);
                myWindow.focus();
              });
            }}
          >
            <i className='fa fa-print color-black' aria-hidden='true' />
            {language.LC().PRINT_QA_MOCK}
          </DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    </span>
  );
}

export default PrintButton;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/PrintButton.jsx